import * as children from './pages/**/routes.js'; //eslint-disable-line

const PageAccessGroups = () => import('./PageAccessGroups');

export default {
  path: 'access-groups',
  children: {
    listAccessGroups: {
      name: 'access-groups',
      path: '',
      component: PageAccessGroups,
      meta: {
        title: 'Gerenciar Grupos de Acesso',
      },
    },
    ...children,
  },
};



// WEBPACK FOOTER //
// ./src/features/private/settings/pages/access-groups/routes.js